import { isAxiosError } from 'axios';
import { stringify } from 'qs';
import { useState } from 'react';
import { getQueryFromParams } from 'providers/data/helpers';
import { useDataProvider, useListContext, useNotify, useTranslate } from 'react-admin';

export function useUnitsCsvExport() {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const translate = useTranslate();
  const { filterValues, sort } = useListContext();
  const [loading, setLoading] = useState<boolean>(false);

  const handleExport = async () => {
    const query = getQueryFromParams({
      pagination: { page: 1, perPage: 1 },
      filter: filterValues,
      sort,
    });
    delete query.page;
    delete query.perPage;
    const queryString = stringify(query);
    const url = `reports/download/unitsFullExportCsv${queryString ? `?${queryString}` : ''}`;
    const item = translate('resources.units.list.export_csv');

    try {
      setLoading(true);
      notify('custom.notification.download_started', {
        type: 'success',
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        messageArgs: { item },
      });
      await dataProvider.download(url);
      notify('custom.notification.download', {
        type: 'success',
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
        messageArgs: { item },
      });
    } catch (error) {
      if (isAxiosError(error)) {
        notify('ra.page.error', { type: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
      }
    } finally {
      setLoading(false);
    }
  };

  return { handleExport, loading };
}
